const DEFAULT_ELIGIBILITY_API_URL = "https://api.pro.alexepstein.ai";

type ClaimResponse = {
  eligible: boolean;
  products?: unknown;
};

export type EligibilityClaimResult = {
  eligible: boolean;
  products: string[];
};

type ClaimEligibilityOptions = {
  token: string;
  fetchImpl?: typeof fetch;
};

function endpointUrl(): string {
  const baseUrl =
    import.meta.env.VITE_ELIGIBILITY_API_URL || DEFAULT_ELIGIBILITY_API_URL;
  return `${baseUrl.replace(/\/$/, "")}/account/claim-eligibility?product=etp`;
}

/**
 * Redeem live eligibility rows for the signed-in user's verified primary
 * email. The server derives identity from the Clerk bearer token and grants
 * only products present on the matching eligibility rows.
 */
export async function claimMemberEligibility({
  token,
  fetchImpl = fetch,
}: ClaimEligibilityOptions): Promise<EligibilityClaimResult> {
  const response = await fetchImpl(endpointUrl(), {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });

  if (response.status === 404) {
    return { eligible: false, products: [] };
  }
  if (!response.ok) {
    throw new Error(`Eligibility claim failed with status ${response.status}`);
  }

  const body = (await response.json()) as ClaimResponse;
  if (body.eligible !== true || !Array.isArray(body.products)) {
    throw new Error("Eligibility claim returned an invalid response");
  }

  return {
    eligible: true,
    products: body.products.filter(
      (product): product is string => typeof product === "string",
    ),
  };
}
